import { render, staticRenderFns } from "./FollowersView.vue?vue&type=template&id=1f756b14&scoped=true&"
import script from "./FollowersView.vue?vue&type=script&lang=ts&"
export * from "./FollowersView.vue?vue&type=script&lang=ts&"
import style0 from "./FollowersView.vue?vue&type=style&index=0&id=1f756b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f756b14",
  null
  
)

export default component.exports